import { APIErrorHandler } from './contracts/api-error-handler.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, ObservableInput, throwError } from 'rxjs';
import { APIError } from './contracts/api-error.model';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class HspaAPIErrorHandler implements APIErrorHandler {

  constructor(private injector: Injector) { }

  handleError<T>(err: HttpErrorResponse, caught?: Observable<T>): ObservableInput<APIError> {
    if (err !== null && err.status !== null && err.status == 403) {
      this.injector.get(Router).navigate(['/not-authorized']);
    }
    const response: APIError = {
      code: 0,
      message: '',
      errors: {}
    };

    if(err.error!=null && err.error){
    response.message = err.error instanceof ErrorEvent ?
      err.message : err.error.Message !== undefined ? err.error.Message : err.error.title;
    }else{
      response.message = err.message;
    }
    response.code = err.status;

    if (err.error?.errors !== undefined) {
      response.message = err.error.title;
      response.errors = err.error.errors;
    }
    return throwError(response);
  }
}
